import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { forwardRef } from 'react';
import { cn, Spinner, FaIcon } from '@fe-learner-common';
import { ButtonProps } from './Button';

interface IconButtonProps extends ButtonProps {
  icon: IconDefinition;
}

const Icon = ({ icon }: { icon: IconDefinition }) => (
  <FaIcon
    className="aspect-square text-inherit"
    icon={icon}
    width={16}
    height={16}
  />
);

const iconSizeMap = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, loading, name, size, ariaLabel, ...rest }, ref) => {
    return (
      <button
        {...rest}
        aria-label={ariaLabel}
        ref={ref}
        className={cn(
          'l-btn',
          'flex flex-shrink-0 rounded-lg',
          iconSizeMap[size],
          'disabled:cursor-default',
          className,
        )}
      >
        {loading ? <Spinner name={name} /> : <Icon icon={icon} />}
      </button>
    );
  },
);
IconButton.displayName = 'IconButton';

export const TertiaryIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(({ className, ...rest }, ref) => {
  return (
    <IconButton
      className={cn('l-btn-tertiary', className)}
      ref={ref}
      {...rest}
    />
  );
});
TertiaryIconButton.displayName = 'TertiaryIconButton';
